// import { useEffect } from 'react';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import i18n from 'i18next';
// import i18next from "i18next";

// function useLanguageUrl() {
//   const {pathname,state} = useLocation();
//   const navigate = useNavigate();
//   const { lang: _lang } = useParams();
//   const lang = _lang || "en";
  
//   useEffect(() => {
// 	if(lang === "en" || lang=== "sp")
//   {
//     i18next.changeLanguage(lang);
//   }
    
//     const path = pathname;
    
//     if (pathname === "/") {
//       navigate(`/${lang}`, {state})
//   }
//   const currentLang = i18n.language;
  
//   const languageSupport = ["en","sp"]


//     if (!languageSupport.includes(path.split('/')[1])) {

//    const secondSlashIndex = path.indexOf('/', path.indexOf('/') + 1); 
//    const hasSecondSlash = secondSlashIndex > -1; 
   
//    const thirdSlashIndex = path.indexOf('/', path.indexOf('/') + 2); 
//    const hasThirdSlash = thirdSlashIndex > -1; 
   
        
//       if(hasSecondSlash)
//       {
//         const newUrl = pathname.replace(/\/(?!en|sp)[^/]+/, '');
//         return navigate(`/${currentLang}${newUrl}`, {state})         
//       }
//       else if(hasThirdSlash)
//       {
//         const newUrl = pathname.replace(/\/(?!en|sp)[^/]+/, '');
//         return navigate(`/${currentLang}${newUrl}`, {state})  
//       }
//       else{
//         return navigate(`/${currentLang}${path}`, {state})         
//       }
//     }
    
// }, [pathname,navigate]);
// }

// export default useLanguageUrl;


import { useEffect } from "react";
import { useLocation ,useParams,useNavigate} from "react-router-dom";
import i18n from 'i18next';
import i18next from "i18next";
import { LANGUAGES } from "assets/constants";

const normalizeLang = (value) => {
  const lang = (value || "").toLowerCase().split("-")[0];
  return LANGUAGES.includes(lang) ? lang : "sp";
};

const hasLikelyInvalidLangPrefix = (segment = "") =>
  segment.includes("-") || /^[a-z]{2}_[a-z]{2}$/i.test(segment);

const useLanguageUrl = () => {
  
  const { lang: _lang } = useParams();
  const lang = normalizeLang(_lang);
  
  const navigate = useNavigate();
  const { pathname } = useLocation();
  i18next.changeLanguage(lang);

  const currentLang = normalizeLang(localStorage.getItem("i18nextLng"));

  const languageInUrl = pathname.split("/")[1];
  
  useEffect(() => {
    if (!["en", "sp"].includes(languageInUrl)) {
      if (hasLikelyInvalidLangPrefix(languageInUrl)) {
        const strippedPath = pathname.replace(/^\/[^/]+/, "") || "/";
        return navigate(`/${currentLang}${strippedPath}`, { replace: true });
      }

      const modifiedUrl = `/${currentLang}${pathname}`;
      return navigate(modifiedUrl, { replace: true });
    }
  }, [pathname, currentLang, languageInUrl]);
};

export default useLanguageUrl;
